export enum EntryValidation {
    Required = 'Fill time field',
    NotEmpty = 'Time cannot be less than 1 minute',
    Exceed = 'An activity\'s duration totals for a day should not exceed 24 hours',
}
